import React, {
  useEffect,
  useState
} from 'react';
import { flowRight } from 'lodash';
import {
  ELSPropsFromModalService,
  ELSWithModalService
} from '@els/els-component-modal-react';
import { useLocation } from 'react-router';
import { Location } from 'history';
import {
  ELSCommonUIConstants,
} from '@els/els-ui-common-react';
import { RecordEmpty } from '../../models/common.models';
import {
  AdobeAnalyticsAction,
  AdobeLoginStatus
} from '../../models/adobe-analytics.models';
import { trackAdobeAction } from '../app/app-state-actions.utilities';
import {
  convertPathToName,
  getRoutePathByPath,
  RouteConfig,
  RouteConfigMap
} from '../app/app.routes';

export type LocationChangeHandlerPropsOnly = RecordEmpty;

export type LocationChangeHandlerProps = ELSPropsFromModalService;

const LocationChangeHandler = (props: LocationChangeHandlerProps) => {

  const [lastLoggedRoute, setLastLoggedRoute] = useState<string>(null);

  const location: Location = useLocation();

  useEffect(() => {
    props.modalService.closeAllModal();
  }, [location]);

  useEffect(() => {

    const route = getRoutePathByPath(location.pathname);
    const config: RouteConfig = RouteConfigMap[route];

    if (config?.isPrivate && window.pageData?.visitor?.loginStatus !== AdobeLoginStatus.LOGGED_IN) {
      return;
    }

    if (lastLoggedRoute === location.pathname) {
      return;
    }

    setLastLoggedRoute(location.pathname);

    trackAdobeAction({
      action: AdobeAnalyticsAction.NEW_PAGE,
      pageData: {
        page: {
          loadTimestamp: new Date().getTime().toString(),
          loadTime: 0,
          name: config ? config.data.analytics.pageName : convertPathToName(location.pathname),
          type: config ? config.data.analytics.pageType : ELSCommonUIConstants.analytics.pageTypes.genericNav,
        }
      }
    });

  }, [location.pathname, window.pageData?.visitor?.loginStatus]);

  return null;
};

const enhance = flowRight(
  ELSWithModalService,
);

export default enhance(LocationChangeHandler) as React.FC<LocationChangeHandlerPropsOnly>;
